import gtmTrackerMiddlewareCreator from './gtmMiddleware';

export default gtmTrackerMiddlewareCreator;
